// Core
import React from 'react';

function Icon(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      data-testid="file-warning"
    >
      <g clipPath="url(#clip0_threshold_config_error)">
        <path
          d="M18.5 5.66665H6.83333V24.3333H23.1667V10.3333H18.5V5.66665ZM4.5 4.49065C4.5 3.85131 5.0215 3.33331 5.6655 3.33331H19.6667L25.5 9.16665V25.4918C25.5011 25.645 25.472 25.7969 25.4143 25.9389C25.3567 26.0809 25.2717 26.2101 25.1641 26.3192C25.0565 26.4283 24.9285 26.5151 24.7873 26.5747C24.6462 26.6343 24.4947 26.6656 24.3415 26.6666H5.6585C5.35211 26.6645 5.05885 26.5419 4.84209 26.3254C4.62532 26.1088 4.50244 25.8157 4.5 25.5093V4.49065ZM13.8333 18.5H16.1667V20.8333H13.8333V18.5ZM13.8333 9.16665H16.1667V16.1666H13.8333V9.16665Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_threshold_config_error">
          <rect width="28" height="28" fill="white" transform="translate(1 1)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
